import React from 'react'
import { RouteComponentProps } from 'react-router'
import DocumentTitle from 'react-document-title'
import env from 'constants/env.json'
import { getRouteByPath } from 'services/module'
import { LayoutProvider } from './LayoutContext'
export default class extends React.PureComponent<RouteComponentProps<any>> {
  currRoute?: IRoute = undefined
  getPageTitle() {
    const { location } = this.props
    const pathname = location.pathname
    let title = env.displayName
    let route = getRouteByPath(pathname)
    if (route) {
      if (route.layout === 'public') {
        return title
      }
      if (route.name) return `${title}-${route.name}`
    }
    return title
  }
  render() {
    return (
      <LayoutProvider>
        {/* <DocumentTitle title={this.getPageTitle()}>
          {this.props.children}
        </DocumentTitle> */}
        {this.props.children}
      </LayoutProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/LayoutBase.tsx